import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import { IAttachDocument } from 'src/types/AttachDocument';
import axiosInstance from 'src/utils/axios';

interface UpdateDetailsRequest {
  id: number;
}

interface AttachDocumentResponse {
  totalRecords: number;
  items: IAttachDocument[];
}

const useGetUpdatedReceiptOrInvoiceDetailsApi = (isInvoice: boolean) => {
  const call = useCallback(
    (params?: UpdateDetailsRequest) =>
      new Promise<AttachDocumentResponse>((resolve, reject) => {
        const id: number = params?.id as number;
        axiosInstance
          .get<AttachDocumentResponse>(
            isInvoice ? api.getInvoiceDataUrlGenerator(id) : api.getReceiptDataUrlGenerator(id)
          )
          .then((response) => resolve(response.data))
          .catch((error) => {
            reject(error);
          });
      }),
    [isInvoice]
  );

  const { execute, isLoading } = useAsync(call, false);

  return {
    updateReceiptOrInvoiceDetails: execute,
    isAttachDocumentLoading: isLoading,
  };
};

export default useGetUpdatedReceiptOrInvoiceDetailsApi;
